import { PayloadAction } from '@reduxjs/toolkit';

import { AuthState } from '../types';

export function error(state: AuthState, action: PayloadAction<Error>) {
  state.loading = false;
  state.error = action.payload;
}
